import React from 'react'
import { IconButtonProps } from './IconButton.types'
import { StyledIconButton } from './IconButton.styles'

export const IconButton: React.FC<IconButtonProps> = ({
  size = 'medium',
  variant = 'default',
  children,
  ...props
}) => {
  return (
    <StyledIconButton $size={size} $variant={variant} {...props}>
      {children}
    </StyledIconButton>
  )
}
